import axios from 'axios';

import { store , defineListControllers  } from "../state/redux";


export const  axios_devis_findformulesfromliste= async (listeids)=>{
    return  await  axios({method:'POST',url:`/devis/findformulesfromliste`,data:{listeids},headers:{ 'Accept': 'application/json', 'Content-Type': 'application/json'  } });
}

export const  axios_devis_downloaddevis = async ({user,lead,sol1,sol2,sol3})=>{

    return   await  axios({url:'/devis/downloaddevis',method:'post',data:{user,lead,sol1,sol2,sol3},responseType:'blob'}) 
}

export const  axios_devis_registerdevis= async (datadevis)=>{
    return   await  axios.post(`/devis/registerdevis`,datadevis,{headers:{'Accept':'application/json'}});
}

export const  axios_devis_finddevis= async (id_lead)=>{
    const controller = new AbortController();
    const actucontrollers = store.getState().formules.listcontrollers ;
    store.dispatch(defineListControllers([...actucontrollers,controller]))  ;
    return   await  axios.post(`/devis/finddevis/`,{id_lead},{signal: controller.signal},{headers:{'Accept':'application/json'}}) ;
}
